<template>
  <BaseFigureComponent>
    <BaseImageComponent
      :srcset="image?.formats && useSrcSet ? srcset : null"
      :src="url"
      :width="image?.width"
      :height="image?.height"
      :filename="image?.name"
      :alt="image?.alternativeText"
      :use-src-set="useSrcSet"
    />

    <template v-if="$slots.caption" #caption>
      <slot name="caption" />
    </template>
  </BaseFigureComponent>
</template>

<script setup lang="ts">
const props = defineProps<{
  image: StrapiImage
}>()

const url = baseStrapiGetAbsoluteFileUrl(props.image?.url, props.image?.provider)
const srcset = Object.values(props.image?.formats || {})?.sort((a, b) => a?.width - b?.width)?.map((format: any) => `${baseStrapiGetAbsoluteFileUrl(format?.url, props?.image?.provider)} ${format?.width}w`).join(', ')

const useSrcSet = computed(() => {
  if (props?.image?.formats) {
    return Object.keys(props?.image?.formats)?.includes('large')
  } else {
    return false
  }
})
</script>
